import { Store } from 'lucide-react'

interface BusinessesEmptyStateProps {
  hasFilters: boolean
}

export function BusinessesEmptyState({ hasFilters }: BusinessesEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-card border border-dashed border-line bg-panel p-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-accent-soft text-accent-dark">
        <Store className="h-7 w-7" />
      </div>
      <h2 className="mt-5 font-serif text-2xl font-normal text-ink">
        {hasFilters ? 'Sin resultados' : 'Aún no tienes negocios'}
      </h2>
      <p className="mt-2 max-w-md text-sm text-ink-muted">
        {hasFilters
          ? 'No encontramos negocios que coincidan con tu búsqueda. Ajusta los filtros e inténtalo de nuevo.'
          : 'Cuando crees tu primer negocio aparecerá aquí con su estado, servicios y facturación.'}
      </p>
    </div>
  )
}
